import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class AuditLogProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'audit-logs'
}

